module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-card', [_c('v-card-title', {
    staticClass: "subtitle-1 overline",
    attrs: {
      "touchless": ""
    }
  }, [_vm._v("\n    Add a new member to your team\n  ")]), _vm._v(" "), _c('v-window', {
    attrs: {
      "vertical": ""
    },
    model: {
      value: (_vm.active),
      callback: function($$v) {
        _vm.active = $$v
      },
      expression: "active"
    }
  }, [_c('v-window-item', [_c('v-card', {
    attrs: {
      "flat": ""
    }
  }, [_c('v-card-title', {
    staticClass: "subtitle-1 overline"
  }), _vm._v(" "), _c('v-card-text', [_c('v-text-field', {
    staticClass: "ag-input-xl",
    attrs: {
      "outline": "",
      "label": "Email address",
      "type": "email"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Phone",
      "type": "phone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "registration number"
    }
  }), _vm._v(" "), _c('v-radio-group', {
    attrs: {
      "row": ""
    }
  }, [_c('v-radio', {
    attrs: {
      "label": "member"
    }
  }), _vm._v(" "), _c('v-radio', {
    attrs: {
      "label": "owner"
    }
  })], 1)], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-actions', [_c('v-spacer'), _vm._v(" "), _c('v-btn', {
    attrs: {
      "color": "primary"
    },
    on: {
      "click": _vm.next
    }
  }, [_vm._v("\n      Next\n    ")])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-39493a17","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/actions/InviteMember/index.vue
// module id = 1655
// module chunks = 1